const LOGIN = "LOGIN";
const AGENT_INFO = "AGENT_INFO";
const SELLERS = "SELLERS";

export { LOGIN, AGENT_INFO, SELLERS };